export const checkIfDeviceIsTouchScreen: () => boolean = () => {
  if (typeof window != 'undefined' && window.matchMedia) {
    return window.matchMedia('(pointer: coarse)').matches;
  } else {
    return false;
  }
};
